import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Modal from './Modal';

export interface IReportModalProps {
  modalOpen: boolean;
  setModalOpen: (open: boolean) => void;
  messageId: string;
}

export const WaitModal: React.FunctionComponent<IReportModalProps> = props => {
  return (props.modalOpen ? 
    <Modal 
      onClose={() => props.setModalOpen(false)}
      closeOnClickOutside={true}
      width={400}>
      <div className="ModalView">
        <div className="spinner"/>
        <div className="message"><FormattedMessage id={props.messageId}/></div>
      </div>
    </Modal>
    : null
  );
}

export const ReadyModal: React.FunctionComponent<IReportModalProps> = props => {
  return (props.modalOpen ?
    <Modal 
      onClose={() => props.setModalOpen(false)}
      closeOnClickOutside={true}
      width={400}
      height={200}>
      <div className="ModalView">
        <div className="checkmark">
          <FontAwesomeIcon icon="check-circle" color="var(--serty-green)" size="5x" />
        </div>
        <div className="message"><FormattedMessage id={props.messageId}/></div>
      </div>
    </Modal>
    : null
  );
}

export interface IAlertModalProps {
  modalOpen: boolean;
  onDismiss: () => void;
  messageId: string;
  modalText?: string;
}

export const AlertModal: React.FunctionComponent<IAlertModalProps> = props => {
  return (props.modalOpen ?
    <Modal 
      onClose={() => props.onDismiss()}
      closeOnClickOutside={true}
      width={400}
      height={350}>
      <div className="ModalView">
        <FontAwesomeIcon className="checkmark" icon="exclamation-triangle" color="var(--serty-orange)" size="5x"/>
        <div className="message"><FormattedMessage id={props.messageId}/></div>
        <div className="errortext">{props.modalText}</div>
      </div>
      <div className="modal-buttons">
        <button className="send-button btn btn-primary"
                onClick={() => { props.onDismiss(); }}>
          <FormattedMessage id='settings.collectionpoints.ok'/>
        </button>
      </div>
    </Modal>
    : null
  );
}

export interface IConfirmModalProps {
  modalOpen: boolean;
  labelId: string;
  messageId: string;
  submitId: string;
  dismissId: string;
  modalText?: string;
  onDismiss: () => void;
  onSubmit: () => void;
}

export const ConfirmModal: React.FunctionComponent<IConfirmModalProps> = props => {
  return (props.modalOpen ? 
    <Modal onClose={() => props.onDismiss()}
          closeOnClickOutside={false}
          width={400} height={props.modalText ? 450 : 400}>
      <div className="ModalView">
        <FontAwesomeIcon className="checkmark" icon="question-circle" color="var(--serty-grey)" size="5x"/>
        <label><FormattedMessage id={props.labelId}/></label>
        <div className="errortext">{props.modalText}</div>
        <div className="text"><FormattedMessage id={props.messageId}/></div>
        <div className="modal-buttons">
          <button className="send-button btn btn-primary"
                  onClick={() => { props.onSubmit(); }}>
            <FormattedMessage id={props.submitId}/>
          </button>
          <button className="clear-button btn btn-secondary"
                  onClick={() => { props.onDismiss(); }}>
            <FormattedMessage id={props.dismissId}/>
          </button>
        </div>
      </div>
    </Modal>
    : null
  );
}